import * as React from 'react';

import { useOfferContext } from '../../../context';
import {
  getBalcony,
  getBuildingDeadline,
  getBuildingStatus,
  getLeasePeriod,
  getMaterialType,
  getLandType,
  getLift,
  isSuburban,
  isRent,
  isResidential,
} from '../../../utils/offers';
import { Type } from 'shared/components/OfferCard/Type';

export const OfferTypeContainer = () => {
  const { offer } = useOfferContext();

  const { category, building, loggiasCount, balconiesCount } = offer;

  const texts = React.useMemo(() => {
    const types: (string | null | undefined)[] = [getLeasePeriod(offer)];

    if (!isRent(offer.dealType) && !isSuburban(offer.category)) {
      types.push(
        getMaterialType(offer.building),
        getBuildingStatus(offer.category),
        getBuildingDeadline(offer.building),
      );
    }

    if (isSuburban(offer.category)) {
      types.push(getLandType(offer.land));
    }

    if (isResidential(category) && !isSuburban(category)) {
      types.push(getBalcony({ loggiasCount, balconiesCount }), getLift(building));
    }

    return types.filter(Boolean).map((type, index, arr) => `${type}${index === arr.length - 1 ? '' : ',\u00A0'}`);
  }, [balconiesCount, building, category, loggiasCount, offer]);

  return <Type texts={texts} />;
};
